import React, { useState, useEffect } from "react";
import DefectFormApi from "../../../../api/DefectForm";
import * as M from "moment";
import Constants from "../../../../constants/Common";
import { IDefectHistory } from "./types";
import { IButton } from "../../../../ui-kit";
import classNames from "classnames";
import styles from "./defectHistory.module.scss";

const DefectHistory: React.FC<{ defectId: string }> = ({ defectId }) => {
  const [initialDefectHistory, setInitialDefectHistory] = useState<
    IDefectHistory[]
  >([]);
  const [isVisibleTable, setIsVisibleTable] = useState(false);

  useEffect(() => {
    DefectFormApi.getEventHistory(defectId)
      .then((res) => {
        const changedAttributes = res.data.filter((attr) => attr.previousValue);
        setInitialDefectHistory(changedAttributes);
      })
      .catch((err) => {
        console.log("история дефекта не найдена", err);
      });
  }, [defectId]);

  const handleVisibleTable = (): void => {
    setIsVisibleTable((pre) => !pre);
  };

  const attributeCount =
    initialDefectHistory &&
    initialDefectHistory!.filter((item) => item.previousValue).length;

  return (
    <div className={styles.defectHistory}>
      <p className={styles.defectHistory__title}>
        История изменения дефекта № {defectId}
      </p>
      <table className={styles.defectHistory__table}>
        <tbody>
          <tr className={styles.defectHistory__tableGroupHead}>
            <th>Количество измененных атрибутов:</th>
            <th>{attributeCount}</th>
          </tr>
        </tbody>
      </table>
      <IButton
        className={styles.defectHistory__btn}
        onClick={handleVisibleTable}
      >
        {!isVisibleTable ? "Подробнее" : "Свернуть"}
      </IButton>
      <div
        className={classNames(
          styles.defectHistory__container,
          isVisibleTable ? styles.defectHistory__container_visible : "",
        )}
      >
        <table className={styles.defectHistory__table}>
          <thead>
            <tr className={styles.defectHistory__tableGroupHead}>
              <th>Наименование</th>
              <th>Старое значение</th>
              <th>Новое значение</th>
              <th>Дата изменения</th>
            </tr>
          </thead>
          <tbody>
            {initialDefectHistory.length > 0 ? (
              initialDefectHistory!.map((item, idx) => {
                return (
                  <tr
                    className={styles.defectHistory__tableGroupTbody}
                    key={idx}
                  >
                    <td>{item.attributeNameDescription}</td>
                    <td>
                      {(item.previousValue &&
                        item.attributeName === "DateTimePlanned") ||
                      item.attributeName === "DateTimeEnable" ||
                      item.attributeName === "DateTimeDisable"
                        ? M(item.previousValue).format(Constants.dateTimeFormat)
                        : item.previousValue === "False"
                        ? "нет"
                        : item.previousValue === "True"
                        ? "да"
                        : item.previousValue
                        ? item.previousValue
                        : Constants.notSet}
                    </td>
                    <td>
                      {(item.newValue &&
                        item.attributeName === "DateTimePlanned") ||
                      item.attributeName === "DateTimeEnable" ||
                      item.attributeName === "DateTimeDisable"
                        ? M(item.newValue).format(Constants.dateTimeFormat)
                        : item.newValue === "False"
                        ? "нет"
                        : item.newValue === "True"
                        ? "да"
                        : item.newValue
                        ? item.newValue
                        : Constants.notSet}
                    </td>
                    <td>
                      {item.created
                        ? M(item.created).format(Constants.dateTimeFormat)
                        : Constants.notSet}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <th className={styles.defectHistory__warning}>Нет данных</th>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DefectHistory;
